/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';

const PlayMarker = () => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 40 40",
  preserveAspectRatio: "xMinYMin",
  className: "quiver-play-marker"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "20"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "17.5 15, 25 20, 17.5 25"
})));

export default PlayMarker;
//# sourceMappingURL=PlayMarker.js.map
